import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import { getDatabase } from "firebase/database";
import { getStorage, ref, getDownloadURL } from "firebase/storage";

const app = firebase.initializeApp({
  apiKey: "AIzaSyBdIQZAyIUmFo8wphiDIg38xXPBv9F12zY",
  authDomain: "kyraposey-cdc1e.firebaseapp.com",
  projectId: "kyraposey-cdc1e",
  storageBucket: "kyraposey-cdc1e.firebasestorage.app",
  messagingSenderId: "1031690911087",
  appId: "1:1031690911087:web:fb1ed673c65004e1c07c9a",
  measurementId: "G-26M2GWMTE8"
});

const auth = firebase.auth();
const database = getDatabase(app);
const storage = getStorage(app);


export { firebase, auth, database, storage, ref, getDownloadURL };